function isMobilePhoneValid(number) {
    if (!number) return false;

    number = String(number);

    number = number.replace(/ /g, '');

    if (isNaN(number)) return false;

    // MSISDN prefix
    if (number.startsWith('614') || number.startsWith('615')) {
        return number.length === 11;
    }

    // Local prefix
    if (number.startsWith('04') || number.startsWith('05')) {
        return number.length === 10;
    }

    return false;
}

module.exports = function () {
    return {
        require: '^?ngModel',
        restrict: 'A',
        link: (scope, elem, attr, ctrl) => {
            ctrl.$validators.invalidMobilePhone = (modelValue, viewValue) => {
                const value = modelValue || viewValue;
                return isMobilePhoneValid(value);
            };
        },
    };
};



// WEBPACK FOOTER //
// ./src/common/mobilephonevalidator/mobile-phone-validator.directive.js